(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-complete-set"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.getElementById('cart-complete-set-config');
    if (!configElement) return;

    const config = JSON.parse(configElement.textContent);
    const visibleClass = 'cart-complete-set-visible';

    let cartObserver;
    let observedCart;
    let refreshTimer;
    let requestSequence = 0;

    const setOfferVisibility = (visible) => {
      document.documentElement.classList.toggle(visibleClass, visible);
    };

    const getOptionValues = (item) =>
      Object.fromEntries(
        (item.options_with_values || []).map((option) => [String(option.name).toLowerCase(), option.value])
      );

    const fetchComplementaryProduct = async (sourceProductId) => {
      const url = new URL(config.recommendationsUrl, window.location.origin);
      url.searchParams.set('product_id', sourceProductId);
      url.searchParams.set('limit', '1');
      url.searchParams.set('intent', 'complementary');

      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) {
        throw new Error(`Complementary product request failed with ${response.status}`);
      }

      const payload = await response.json();
      return payload.products?.[0] || null;
    };

    const hasExactVariant = (product, desiredOptions) => {
      const optionNames = product.options.map((option) =>
        String(option.name || option).toLowerCase()
      );

      return product.variants.some((variant) => {
        if (!variant.available) return false;
        return ['color', 'size'].every((optionName) => {
          const optionIndex = optionNames.indexOf(optionName);
          if (optionIndex < 0 || !desiredOptions[optionName]) return false;
          return String(variant.options[optionIndex]) === String(desiredOptions[optionName]);
        });
      });
    };

    const getEligibility = async (cart) => {
      const paidPhysicalItems = (cart?.items || []).filter(
        (item) => item.requires_shipping && item.final_line_price > 0
      );
      if (paidPhysicalItems.length !== 1 || paidPhysicalItems[0].quantity !== 1) return null;

      const sourceItem = paidPhysicalItems[0];
      const targetProduct = await fetchComplementaryProduct(String(sourceItem.product_id));
      if (!targetProduct) return null;
      if (cart.items.some((item) => String(item.product_id) === String(targetProduct.id))) return null;

      const desiredOptions = getOptionValues(sourceItem);
      if (!hasExactVariant(targetProduct, desiredOptions)) return null;

      return {
        targetHandle: targetProduct.handle,
        color: desiredOptions.color,
        size: desiredOptions.size,
      };
    };

    const isCartOpen = () => {
      const cart = document.querySelector('#kaching-cart, .kaching-cart');
      return Boolean(cart?.classList.contains('active'));
    };

    const setSelectorValue = (selector, value) => {
      const option = [...selector.options].find(
        (candidate) => candidate.value === value && !candidate.disabled
      );
      if (!option) return false;
      if (selector.value === value) return true;

      const nativeValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLSelectElement.prototype,
        'value'
      )?.set;
      if (!nativeValueSetter) return false;

      nativeValueSetter.call(selector, value);
      selector.dispatchEvent(new Event('input', { bubbles: true }));
      selector.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };

    const prepareOffer = async (eligibility) => {
      for (let attempt = 0; attempt < 40; attempt += 1) {
        const offer = document.querySelector('.kaching-cart__side-upsell .kaching-side-upsell-item');
        const productLink = offer?.querySelector('.kaching-side-upsell-item__title');
        const offerPath = productLink?.href ? new URL(productLink.href, window.location.origin).pathname : '';
        const colorSelector = offer?.querySelector('.kaching-cart-selector[aria-label="Color"]');

        if (offer && offerPath.endsWith(`/products/${eligibility.targetHandle}`) && colorSelector) {
          if (!setSelectorValue(colorSelector, eligibility.color)) return false;
          await new Promise((resolve) => window.setTimeout(resolve, 300));

          const currentOffer = document.querySelector(
            '.kaching-cart__side-upsell .kaching-side-upsell-item'
          );
          const sizeSelector = currentOffer?.querySelector(
            '.kaching-cart-selector[aria-label="Size"]'
          );
          if (!sizeSelector || !setSelectorValue(sizeSelector, eligibility.size)) return false;
          await new Promise((resolve) => window.setTimeout(resolve, 300));

          const selectors = document.querySelectorAll(
            '.kaching-cart__side-upsell .kaching-side-upsell-item .kaching-cart-selector'
          );
          const selectedValues = Object.fromEntries(
            [...selectors].map((selector) => [
              selector.getAttribute('aria-label')?.toLowerCase(),
              selector.value,
            ])
          );
          return selectedValues.color === eligibility.color && selectedValues.size === eligibility.size;
        }

        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      return false;
    };

    const fetchCart = async () => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Cart request failed with ${response.status}`);
      return response.json();
    };

    const refresh = async () => {
      const sequence = ++requestSequence;
      try {
        if (!isCartOpen()) {
          setOfferVisibility(false);
          return;
        }

        const cart = await fetchCart();
        if (sequence !== requestSequence) return;

        const eligibility = await getEligibility(cart);
        if (!eligibility) {
          setOfferVisibility(false);
          return;
        }

        const offerReady = await prepareOffer(eligibility);
        if (sequence !== requestSequence) return;
        if (!offerReady) {
          setOfferVisibility(false);
          return;
        }

        setOfferVisibility(true);
      } catch (error) {
        setOfferVisibility(false);
        console.warn('Complete-the-set eligibility failed closed.', error);
      }
    };

    function scheduleRefresh(delay = 250) {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, delay);
    }

    const observeKachingCart = () => {
      const cart = document.querySelector('#kaching-cart, .kaching-cart');
      if (!cart || cart === observedCart) return;

      cartObserver?.disconnect();
      observedCart = cart;
      cartObserver = new MutationObserver((records) => {
        const cartChanged = records.some((record) => {
          if (record.type === 'attributes') return record.target === cart;
          if (record.target.closest?.('.kaching-cart-item-container')) return true;

          return [...record.addedNodes, ...record.removedNodes].some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches('.kaching-cart-item-container') ||
                node.querySelector('.kaching-cart-item-container'))
          );
        });

        if (cartChanged) scheduleRefresh();
      });
      cartObserver.observe(cart, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });
      scheduleRefresh(0);
    };

    const install = () => {
      setOfferVisibility(false);
      observeKachingCart();
      new MutationObserver(observeKachingCart).observe(document.body, { childList: true, subtree: true });

      ['cart:refresh', 'kaching-cart:refresh'].forEach((eventName) => {
        window.addEventListener(eventName, () => scheduleRefresh(100));
        document.addEventListener(eventName, () => scheduleRefresh(100));
      });
      document.addEventListener('click', (event) => {
        if (event.target.closest?.('#kaching-cart, .kaching-cart')) scheduleRefresh(600);
      }, true);
      window.addEventListener('pageshow', () => scheduleRefresh(0));
      scheduleRefresh(0);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', install, { once: true });
    } else {
      install();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
